/**
 * Geometry for the plant map inside the public profile (§2 Impatto).
 *
 * Hand-simplified Italian coastline, no geo library, no GeoJSON, no external
 * asset. Coordinates come from an equirectangular projection of the real
 * bounding box (lon 6.5-18.7, lat 35.3-47.2) onto a 60 × 100 box, so the dots
 * sit where the plants actually are instead of being decorative noise.
 *
 * The map SVG uses a wider `0 0 200 100` viewBox (map + callout + counters in
 * one coordinate space, so nothing has to be positioned in pixels): the boot is
 * drawn inside a `translate(30,0)` group.
 */

/** Mainland, clockwise from the western Alps down to Liguria. */
export const ITALY_PATH =
  "M2.0,10.9 L10.3,9.3 L23.6,1.7 L34.9,5.9 L35.9,12.6 L28.5,15.1 L28.5,23.5 " +
  "L34.4,30.2 L37.9,39.5 L47.7,44.5 L51.2,51.3 L58.5,59.6 L58.2,62.2 L52.7,57.1 " +
  "L49.2,61.3 L52.2,68.1 L49.7,70.6 L45.0,76.4 L45.8,71.4 L41.3,60.5 L37.9,53.8 " +
  "L34.9,50.4 L28.0,45.4 L23.1,40.3 L18.7,31.1 L16.2,26.0 L11.8,23.5 L7.4,27.7 " +
  "L4.9,28.6 L2.5,20.2 L1.5,15.1 Z";

export const SICILIA_PATH =
  "M29.0,77.3 L33.9,75.6 L42.8,74.8 L42.3,81.4 L42.3,88.2 L39.4,88.2 L30.0,80.6 Z";

export const SARDEGNA_PATH =
  "M8.4,50.4 L15.3,50.4 L16.2,56.3 L15.3,67.2 L13.3,68.1 L9.3,61.3 L8.4,55.4 Z";

type MapDot = { x: number; y: number; label: string };

/**
 * The plants on the map. First entry is the one the story zooms into, it is
 * also the plant named in the profile row above the map.
 */
const HERO_DOT: MapDot = { x: 11.6, y: 15.8, label: "Vigevano (PV)" };

export const DOTS: MapDot[] = [
  HERO_DOT,
  { x: 6.7, y: 21.4, label: "Cherasco (CN)" },
  { x: 26.0, y: 17.9, label: "Rovigo (RO)" },
  { x: 25.2, y: 19.8, label: "Ferrara (FE)" },
  { x: 22.7, y: 37.3, label: "Grosseto (GR)" },
  { x: 33.5, y: 48.0, label: "Frosinone (FR)" },
  { x: 44.5, y: 48.2, label: "Foggia (FG)" },
  { x: 49.7, y: 54.8, label: "Matera (MT)" },
  { x: 37.2, y: 81.5, label: "Caltanissetta (CL)" },
  { x: 10.3, y: 61.3, label: "Oristano (OR)" },
];
